import { AnalyticsStore, RouteStore } from 'bernie-core';
import * as React from 'react';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkLayoutPosition } from 'uitk-react-layout-position';
import { UitkSpacing } from 'uitk-react-spacing';
import { ActivityDetailOffers } from '../../common/__generated__/api';
import { TertiaryButtonTracked } from '../../utils/click-trackers';
import { PopupMessage } from './popup-message';

interface MessageAnchorProps {
  dialogId: string;
  icon?: ActivityDetailOffers.__Icon | null;
  text?: string | null;
  id?: string | null;
  clickAction?: ActivityDetailOffers.ClickAction | null;
  anchorClasses?: string;
  isNestedPopup?: boolean;
  routeStore?: RouteStore;
  analytics?: AnalyticsStore;
  showText?: boolean;
}

export const MessageAnchor = (props: MessageAnchorProps): JSX.Element | null => {
  const {
    dialogId,
    text,
    id,
    icon,
    clickAction,
    anchorClasses,
    routeStore,
    analytics,
    isNestedPopup,
    showText = true
  } = props;
  const params = isNestedPopup ? { pwaDialogNested: dialogId } : { pwaDialog: dialogId };
  const linkRef: React.RefObject<any> = React.useRef();

  if (!routeStore) {
    return null;
  }

  const onClick = (): void => {
    if (routeStore) {
      routeStore.updateSearch(params);
    }
  };

  return (
    <>
      <UitkLayoutPosition type="relative" position={{ top: 'zero', zindex: 'layer2' }}>
        <UitkSpacing padding={{ inlinestart: 'half', blockend: 'half' }}>
          <TertiaryButtonTracked
            key="message-router"
            rfrr={clickAction && clickAction.analytics ? clickAction.analytics.referrerId : ''}
            linkName="more-info-clicked"
            domRef={linkRef}
            onClick={onClick}
          >
            <span data-testid={dialogId} className={`${anchorClasses}`}>
              {text && showText && <span>{text}</span>}
              {icon && (
                <UitkSpacing padding={{ inlinestart: 'half', blockend: 'half' }}>
                  <UitkIcon
                    id={id ? id : 'message-anchor'}
                    name={icon.id}
                    size={UitkIconSize.EXTRA_SMALL}
                    aria-label={icon.description}
                    title={icon.description}
                  />
                </UitkSpacing>
              )}
            </span>
          </TertiaryButtonTracked>
        </UitkSpacing>
      </UitkLayoutPosition>
      <PopupMessage
        key="popup-message"
        dialogId={dialogId}
        routeStore={routeStore}
        analytics={analytics}
        clickAction={clickAction}
        isNestedPopup={isNestedPopup}
        linkRef={linkRef}
      />
    </>
  );
};
